module.exports = __webpack_public_path__ + "assets/a2cc715509c968be7d8b72a3148d61e3.png";